/** Shared inline SVG assets for the front-end screens. */

export const dicePips = (faces: number[]): string => {
  const coords: Record<number, [number, number]> = {
    1: [50, 50],
    2: [28, 28],
    3: [72, 72],
    4: [28, 72],
    5: [72, 28],
    6: [28, 50],
    7: [72, 50],
    8: [50, 28],
    9: [50, 72],
  };
  const pips = faces
    .map((f) => `<circle cx="${coords[f][0]}" cy="${coords[f][1]}" r="9"/>`)
    .join("");
  return `<svg viewBox="0 0 100 100" aria-hidden="true">${pips}</svg>`;
};

export const boardSvg = (gold: string): string => `
<svg viewBox="0 0 200 200" aria-hidden="true">
  <defs>
    <linearGradient id="boardGold" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#ffe9a8"/>
      <stop offset="0.5" stop-color="${gold}"/>
      <stop offset="1" stop-color="#a97b12"/>
    </linearGradient>
  </defs>
  <g transform="rotate(45 100 100)">
    <rect x="18" y="18" width="164" height="164" rx="14" fill="url(#boardGold)"/>
    <rect x="26" y="26" width="148" height="148" rx="9" fill="#f4f6fb"/>
    <!-- quadrants -->
    <rect x="30" y="30" width="56" height="56" rx="6" fill="#d9364c"/>
    <rect x="114" y="30" width="56" height="56" rx="6" fill="#2f6fd6"/>
    <rect x="30" y="114" width="56" height="56" rx="6" fill="#2e9e4f"/>
    <rect x="114" y="114" width="56" height="56" rx="6" fill="#e3b52a"/>
    <!-- quadrant bases -->
    <circle cx="58" cy="58" r="17" fill="#fff"/>
    <circle cx="142" cy="58" r="17" fill="#fff"/>
    <circle cx="58" cy="142" r="17" fill="#fff"/>
    <circle cx="142" cy="142" r="17" fill="#fff"/>
    <circle cx="58" cy="58" r="11" fill="#d9364c"/>
    <circle cx="142" cy="58" r="11" fill="#2f6fd6"/>
    <circle cx="58" cy="142" r="11" fill="#2e9e4f"/>
    <circle cx="142" cy="142" r="11" fill="#e3b52a"/>
    <!-- track -->
    <path d="M86 26h28v24h24v28h24v28h-24v24h-24v24h-28v-24H62v-28H38V78h24V50h24z"
          fill="none" stroke="#c9cede" stroke-width="5"/>
    <path d="M86 26h28M86 174h28M26 86v28M174 86v28" stroke="#c9cede" stroke-width="5"/>
    <!-- center home -->
    <path d="M100 82 118 100 100 118 82 100z" fill="#23283f"/>
    <path d="M100 88 112 100 100 112 88 100z" fill="#f4f6fb"/>
    <path d="M100 93 107 100 100 107 93 100z" fill="#d9364c"/>
    <path d="M100 96.5 103.5 100 100 103.5 96.5 100z" fill="#e3b52a"/>
  </g>
</svg>`;

export const iconExit = `
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4"/>
  <polyline points="10 17 5 12 10 7"/>
  <line x1="5" y1="12" x2="16" y2="12"/>
</svg>`;

export const iconSettings = `
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <circle cx="12" cy="12" r="3.2"/>
  <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.55V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1-1.55 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.55-1H3a2 2 0 1 1 0-4h.09a1.7 1.7 0 0 0 1.55-1 1.7 1.7 0 0 0-.34-1.87l-.06-.06A2 2 0 1 1 7.07 4.2l.06.06a1.7 1.7 0 0 0 1.87.34h0a1.7 1.7 0 0 0 1-1.55V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1 1.55h0a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v0a1.7 1.7 0 0 0 1.55 1H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.55 1z"/>
</svg>`;

export const iconRobot = `
<svg viewBox="0 0 96 96" aria-hidden="true">
  <defs>
    <linearGradient id="rb-body" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#ffffff"/>
      <stop offset="0.55" stop-color="#e8ecf7"/>
      <stop offset="1" stop-color="#b9c2d8"/>
    </linearGradient>
    <radialGradient id="rb-eye" cx="0.35" cy="0.3" r="1">
      <stop offset="0" stop-color="#b8fff2"/>
      <stop offset="0.45" stop-color="#57e6c9"/>
      <stop offset="1" stop-color="#12a385"/>
    </radialGradient>
    <linearGradient id="rb-visor" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#2c3252"/>
      <stop offset="1" stop-color="#161a30"/>
    </linearGradient>
  </defs>
  <ellipse cx="48" cy="76" rx="34" ry="9" fill="rgba(255,255,255,0.35)"/>
  <rect x="44" y="10" width="8" height="12" rx="4" fill="#cfd6ea"/>
  <circle class="robot-antenna" cx="48" cy="9" r="5" fill="#f5c542"/>
  <circle cx="48" cy="9" r="2" fill="#fff7d6"/>
  <rect x="20" y="20" width="56" height="46" rx="22" fill="url(#rb-body)"/>
  <rect x="24.5" y="24.5" width="47" height="37" rx="18" fill="none" stroke="#aab4cc" stroke-width="1.6" opacity=".7"/>
  <rect x="27" y="27" width="42" height="32" rx="16" fill="url(#rb-visor)"/>
  <rect x="31" y="31" width="34" height="10" rx="5" fill="#ffffff" opacity=".07"/>
  <g class="robot-eyes">
    <circle class="robot-eye" cx="39" cy="43" r="6" fill="url(#rb-eye)"/>
    <circle class="robot-eye" cx="57" cy="43" r="6" fill="url(#rb-eye)"/>
    <circle cx="40.5" cy="41.5" r="2" fill="#eafffa"/>
    <circle cx="58.5" cy="41.5" r="2" fill="#eafffa"/>
  </g>
  <rect x="42" y="52" width="12" height="3.5" rx="1.75" fill="#eef1fa"/>
</svg>`;

export const iconPlayers = `
<svg viewBox="0 0 96 96" aria-hidden="true">
  <defs>
    <radialGradient id="pl-skin-f" cx="0.35" cy="0.3" r="1.1">
      <stop offset="0" stop-color="#ffdcbf"/>
      <stop offset="0.6" stop-color="#f3bd94"/>
      <stop offset="1" stop-color="#d99a6c"/>
    </radialGradient>
    <radialGradient id="pl-skin-m" cx="0.35" cy="0.3" r="1.1">
      <stop offset="0" stop-color="#f2c69b"/>
      <stop offset="0.6" stop-color="#dfa878"/>
      <stop offset="1" stop-color="#c08a58"/>
    </radialGradient>
    <linearGradient id="pl-hair-f" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#5a3a26"/>
      <stop offset="1" stop-color="#33200f"/>
    </linearGradient>
    <linearGradient id="pl-dress" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#ef7bb0"/>
      <stop offset="1" stop-color="#c2447f"/>
    </linearGradient>
    <linearGradient id="pl-shirt" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#5b8ee0"/>
      <stop offset="1" stop-color="#2f5fb8"/>
    </linearGradient>
    <linearGradient id="pl-hair-m" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#3d2c1c"/>
      <stop offset="1" stop-color="#21150a"/>
    </linearGradient>
  </defs>
  <ellipse cx="48" cy="77" rx="36" ry="8" fill="rgba(255,255,255,0.32)"/>

  <!-- female -->
  <g class="person person--f">
    <path d="M27 44c-4-14 3-27 17-27s21 13 17 27l-3-1c1-11-3-19-14-19s-15 8-14 19z" fill="url(#pl-hair-f)"/>
    <path d="M25 42c-2 8-1 14 2 19l5-2c-2-5-2-11-1-16z" fill="url(#pl-hair-f)"/>
    <path d="M63 42c2 8 1 14-2 19l-5-2c2-5 2-11 1-16z" fill="url(#pl-hair-f)"/>
    <circle cx="44" cy="34" r="13" fill="url(#pl-skin-f)"/>
    <path d="M31 33c0-9 5.5-14.5 13-14.5S57 24 57 33c-2.5-5.5-6.5-8-13-8s-10.5 2.5-13 8z" fill="url(#pl-hair-f)"/>
    <g class="pc-eyes">
      <circle cx="39.5" cy="34.5" r="1.9" fill="#2b2118"/>
      <circle cx="49.5" cy="34.5" r="1.9" fill="#2b2118"/>
      <circle cx="40.1" cy="33.9" r="0.65" fill="#fff"/>
      <circle cx="50.1" cy="33.9" r="0.65" fill="#fff"/>
    </g>
    <path d="M37 31.4c1.4-1 3.2-1 4.4-.1M46.6 31.4c1.4-1 3.2-1 4.4-.1" stroke="#3a2413" stroke-width="1.1" fill="none" stroke-linecap="round"/>
    <circle cx="35.8" cy="38.6" r="2" fill="#f09a9a" opacity=".55"/>
    <circle cx="53.2" cy="38.6" r="2" fill="#f09a9a" opacity=".55"/>
    <path d="M41 40.6c2 1.8 5 1.8 7 0" stroke="#b3775a" stroke-width="1.5" fill="none" stroke-linecap="round"/>
    <path d="M29 66c1-11 7-16.5 15.5-16.5S60 55 61 66z" fill="url(#pl-dress)"/>
    <path d="M41.5 51.5h6l-1.4 5h-3.2z" fill="url(#pl-skin-f)"/>
    <circle cx="44.5" cy="52.4" r="1.4" fill="#ffd9e6"/>
  </g>

  <!-- male -->
  <g class="person person--m">
    <circle cx="66" cy="35" r="12.5" fill="url(#pl-skin-m)"/>
    <path d="M53.5 34c0-8.5 5.5-13.5 12.5-13.5 5.5 0 10 2.6 11.6 7l-3.4 5.2c-3.4-3.6-12-3.8-17.5-.4z" fill="url(#pl-hair-m)"/>
    <path d="M76.8 30.5c1.8 2.4 2.3 5 1.6 7.6l-3-.9c.6-2 .5-4.2-.3-6z" fill="url(#pl-hair-m)"/>
    <g class="pc-eyes">
      <circle cx="62" cy="35.5" r="1.8" fill="#241a10"/>
      <circle cx="71" cy="35.5" r="1.8" fill="#241a10"/>
      <circle cx="62.6" cy="34.9" r="0.6" fill="#fff"/>
      <circle cx="71.6" cy="34.9" r="0.6" fill="#fff"/>
    </g>
    <path d="M59.6 32.6c1.3-.9 3-.9 4.1-.1M68.6 32.6c1.3-.9 3-.9 4.1-.1" stroke="#241608" stroke-width="1.05" fill="none" stroke-linecap="round"/>
    <path d="M63 41.4c1.9 1.7 4.7 1.7 6.6 0" stroke="#9c6b45" stroke-width="1.5" fill="none" stroke-linecap="round"/>
    <path d="M52 66c1-10.5 6.5-15.5 14.5-15.5S80.5 55.5 81.5 66z" fill="url(#pl-shirt)"/>
    <path d="M64.5 51.8h5l-1.2 4.6h-2.6z" fill="url(#pl-skin-m)"/>
    <path d="M62.6 52.2 60 58.5l2.6 1.4zM71.4 52.2l2.6 6.3-2.6 1.4z" fill="url(#pl-shirt)"/>
  </g>

  <!-- shared phone -->
  <g transform="rotate(-7 56 60)">
    <rect x="50" y="54" width="15" height="12.5" rx="2.6" fill="#3d4d70"/>
    <rect x="51.4" y="55.4" width="12.2" height="9.7" rx="1.6" fill="#9fd8ff"/>
    <rect x="52.6" y="56.6" width="7" height="1.3" rx="0.65" fill="#ffffff" opacity=".85"/>
    <rect x="52.6" y="59" width="9.4" height="1.3" rx="0.65" fill="#ffffff" opacity=".55"/>
  </g>
</svg>`;

export const iconGlobe = `
<svg viewBox="0 0 64 64" aria-hidden="true">
  <circle cx="32" cy="32" r="26" fill="#2f8fd6"/>
  <path d="M32 6a26 26 0 0 1 0 52c-5-4-8-13-8-26s3-22 8-26z" fill="#3aa657"/>
  <path d="M32 6a26 26 0 0 0 0 52c5-4 8-13 8-26S37 10 32 6z" fill="#43b85f" opacity="0.85"/>
  <ellipse cx="32" cy="32" rx="26" ry="10" fill="none" stroke="#dff1ff" stroke-width="2.4" opacity="0.7"/>
  <ellipse cx="32" cy="32" rx="11" ry="26" fill="none" stroke="#dff1ff" stroke-width="2.4" opacity="0.7"/>
</svg>`;

export const iconWifi = `
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
     stroke-linecap="round" aria-hidden="true">
  <path d="M2.5 9.5a15 15 0 0 1 19 0"/>
  <path d="M5.5 13a10.5 10.5 0 0 1 13 0"/>
  <path d="M8.6 16.4a6 6 0 0 1 6.8 0"/>
  <circle cx="12" cy="19.6" r="1.4" fill="currentColor" stroke="none"/>
</svg>`;

export const iconCheck = `<svg viewBox="0 0 24 24"><polyline points="4 12.5 10 18.5 20 6.5"/></svg>`;

export const iconFace = `
<svg viewBox="0 0 48 48" aria-hidden="true">
  <circle cx="24" cy="20" r="12" fill="#f7c8a0"/>
  <path d="M12 19c0-8 5.5-12.5 12-12.5S36 11 36 19c-3-4.5-7-6.5-12-6.5S15 14.5 12 19z" fill="#33302f"/>
  <g class="pc-eyes">
    <circle cx="19.5" cy="20" r="1.8" fill="#2b2118"/>
    <circle cx="28.5" cy="20" r="1.8" fill="#2b2118"/>
    <circle cx="20" cy="19.5" r="0.6" fill="#fff"/>
    <circle cx="29" cy="19.5" r="0.6" fill="#fff"/>
  </g>
  <path d="M20 26c2.5 2 5.5 2 8 0" stroke="#b3775a" stroke-width="1.6" fill="none" stroke-linecap="round"/>
</svg>`;
